import React from 'react';
import properties from '../../constants/Properties';
import modeType from '../../constants/ModeConstants';
import { CustomSlider } from './CustomSlider';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import {changeContextMode, changeStyleTab} from '../../actions/MenuActions';
import { ColorPicker } from './ColorPicker';
import shapeTypes from '../../constants/ShapeConstants';
import locales from '../../locales/LocalesManager';
import { OnOffToggleButton } from './OnOffToggleButton';
import appParameters from '../../components/utils/AppParameters';
import platformDetection from '../utils/PlatformDetection';
import mouseUtils from '../../components/utils/MouseUtils';
import videoUtils from '../../components/utils/VideoUtils';

const Title = React.createClass({
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            position: 'absolute',
            top: 6,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        var closeButtonStyle = {
            position: 'absolute',
            right: 28,
            top: 4,
            width: 22,
            height: 22,
            cursor: 'pointer',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            background: 'none',
            borderStyle: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            right: 3,
            cursor: 'pointer'
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('StylingMenuTitle', 'stylingMenu')}</span>

                <button id="firstFocusableObjectForStylingMenu" style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onClick} onTouchEnd={this.onClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        switch (this.props.index) {
            case 0: {
                this.props.dispatch(changeStyleTab(modeType.FILL_STYLE));
                break;
            }

            case 1: {
                this.props.dispatch(changeStyleTab(modeType.LINE_STYLE));
                break;
            }
        }
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.tab != newProps.tab || this.props.contextTarget != newProps.contextTarget)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;
        var isLineSelected = false;

        if (this.props.tab && this.props.tab == modeType.LINE_STYLE)
            isLineSelected = true;

        if (this.props.index == 0) { // Fill button
            if (isLineSelected == false) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = properties.SLIDE_MENU_COLOR;
                }
            }

        } else { // Line button
            if (isLineSelected == true) {
                iconColor = 'white';
                buttonColor = properties.BROWSER_SELECTED_COLOR;
            } else {
                if (this.state.isOver == true) {
                    iconColor = properties.CONTEXT_HOVER_COLOR;
                    buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
                } else {
                    iconColor = 'black';
                    buttonColor = properties.SLIDE_MENU_COLOR;
                }
            }
        }

        var topPosition = properties.CLIPART_BUTTON_HEIGHT + properties.STYLING_TOP_GAP;
        var left = this.props.index == 0 ? properties.STYLING_LEFT_GAP : this.props.accordionWidth / 2;

        var buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth / 2 - properties.STYLING_LEFT_GAP,
            height: properties.STYLING_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            left: left,
            top: topPosition,
            color: 'white',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#333333',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
        };

        const cornerRadius = 8;

        if (this.props.index == 0) {
            buttonStyle.borderTopLeftRadius = cornerRadius;
            buttonStyle.borderBottomLeftRadius = cornerRadius;
        } else if (this.props.index == 1) {
            buttonStyle.borderTopRightRadius = cornerRadius;
            buttonStyle.borderBottomRightRadius = cornerRadius;
        }

        const spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 16,
            position: 'absolute',
            left: 60,
            top: 13
        };

        var iconStyle = {
            position: 'absolute',
            left: 40,
            color: iconColor
        };

        var icon;
        var text = this.props.text;

        if (this.props.index == 0) {
            text = locales.getCaption('FillButton', 'stylingMenu');
            icon = 'fa fa-square';
            iconStyle.top = 14;
        } else {
            text = locales.getCaption('LineButton', 'stylingMenu');
            icon = 'fa fa-minus';
            iconStyle.top = 18;
        }

        if (platformDetection.isIOS() == true) {
            iconStyle.left = 10;
            spanStyle.fontSize = 14;
            spanStyle.left = 29;
            spanStyle.top = 13;
        }

        return (
            <button aria-label={text} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <i style={iconStyle} className={icon}></i>
                <span style={spanStyle}>{text}</span>
            </button>
        );
    }
});

const StylingMenuContent = React.createClass({
    componentDidMount() {
        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('firstFocusableObjectForStylingMenu');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    getTarget () {
        var shapeModel;

        if (this.props.contextMode == modeType.SLIDE_CONTEXT_STYLING) {
            const state = storeManager.getState();
            shapeModel = state.currentSlide.model.content[0];
        } else {
            shapeModel = this.props.contextTarget;
        }

        return shapeModel;
    },
    getType(shapeModel) {
        if (this.props.contextMode == modeType.SLIDE_CONTEXT_STYLING && videoUtils.isVideoBackground())
            return 'FillAndLine';

        if (shapeModel.type == shapeTypes.GROUP) {
            var shapes = shapeModel.shapes;
            var isStrokeOnly = true;

            for (var i=0; i<shapes.length; i++) {
                if (shapes[i].type == shapeTypes.FREEHAND || shapes[i].type == shapeTypes.CURVE || shapes[i].type == shapeTypes.LINE) {

                } else {
                    isStrokeOnly = false;
                    break;
                }
            }

            if (isStrokeOnly)
                return 'Line';
            else
                return 'FillAndLine';
        }

        if (shapeModel.type == shapeTypes.RECTANGLE || shapeModel.type == shapeTypes.TRIANGLE || shapeModel.type == shapeTypes.STAR || shapeModel.type == shapeTypes.HEART || shapeModel.type == shapeTypes.ELLIPSE || shapeModel.type == shapeTypes.BACKGROUND || shapeModel.type == shapeTypes.CHARACTER || shapeModel.type == shapeTypes.IMAGE || this.isTextElement(shapeModel) == true)
            return 'FillAndLine';
        else
            return 'Line';
    },
    isTextElement(shapeModel) {
        if (shapeModel.type == shapeTypes.TEXTBOX || shapeModel.type == shapeTypes.TEXTBOXSIMPLE || shapeModel.type == shapeTypes.SPEAK_BUBBLE || shapeModel.type == shapeTypes.COMPLEX_SPEAK_BUBBLE || shapeModel.type == shapeTypes.SCREAM_BUBBLE || shapeModel.type == shapeTypes.THOUGHT_BUBBLE)
            return true;
        else
            return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.tab != newProps.tab || this.props.windowWidth != newProps.windowWidth || this.props.windowHeight != newProps.windowHeight || this.props.contextMode != newProps.contextMode || this.props.accordionWidth != newProps.accordionWidth || this.props.contextTarget != newProps.contextTarget  || this.props.currentSlideModel != newProps.currentSlideModel)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.contextMode != modeType.OBJECT_CONTEXT_STYLING && this.props.contextMode != modeType.SLIDE_CONTEXT_STYLING)
            return <div/>;

        const menuStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            cursor: 'default'
        };

        const contextTarget = this.getTarget();
        const type = this.getType(contextTarget);
        var buttonsDisplayState = 'none';
        var topPosition = properties.CLIPART_BUTTON_HEIGHT + properties.STYLING_TOP_GAP;

        if (type == 'FillAndLine') {
            buttonsDisplayState = 'block';
            topPosition = properties.CLIPART_BUTTON_HEIGHT + 2 * properties.STYLING_TOP_GAP + properties.STYLING_BUTTON_HEIGHT;
        }

        const buttonsWrapperStyle = {
            display: buttonsDisplayState
        };

        const spanStyle = {
            position: 'absolute',
            left: properties.STYLING_LEFT_GAP,
            top: topPosition,
            cursor: 'default'
        };

        topPosition = topPosition + 30;
        const colorPickerTopPosition = topPosition;

        topPosition = topPosition + properties.RAINBOW_HEIGHT + properties.STYLING_TOP_GAP;

        const spanThicknessStyle = {
            position: 'absolute',
            left: properties.STYLING_LEFT_GAP,
            top: topPosition,
            cursor: 'default'
        };

        topPosition = topPosition + properties.STYLING_TOP_GAP + 5;

        var startVal = 0;

        if (contextTarget.type == shapeTypes.LINE || contextTarget.type == shapeTypes.FREEHAND || contextTarget.type == shapeTypes.CURVE)
            startVal = 1;

        var thicknessProperties = {};
        thicknessProperties.topPosition = topPosition;
        thicknessProperties.leftPosition = properties.STYLING_LEFT_GAP;
        thicknessProperties.width = properties.BROWSER_WIDTH - 2 * properties.STYLING_LEFT_GAP;
        thicknessProperties.height = properties.STYLING_SLIDER_HEIGHT;
        thicknessProperties.backgroundHref = appParameters.RESOURCES_LOCATION() + 'assets/strokeSlider.png';
        thicknessProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        thicknessProperties.thumbSize = properties.STYLING_THUMB_SIZE;
        thicknessProperties.start = startVal;
        thicknessProperties.end = 10;
        thicknessProperties.step = 1;
        thicknessProperties.target = contextTarget;
        thicknessProperties.dispatch = this.props.dispatch;
        thicknessProperties.type = 'change_stroke';

        var lineStyleHolderVisible = 'none';
        var text = locales.getCaption('FillColor', 'stylingMenu');
        var operationType = modeType.FILL_STYLE;

        if (this.props.tab == modeType.LINE_STYLE || type == 'Line') {
            lineStyleHolderVisible = 'block';
            text = locales.getCaption('LineColor', 'stylingMenu');
            operationType = modeType.LINE_STYLE;
        }

        const lineStyleHolder = {
            display: lineStyleHolderVisible
        };

        var onOffButtonProperties = {};
        onOffButtonProperties.topPosition = colorPickerTopPosition + properties.RAINBOW_HEIGHT + properties.STYLING_TOP_GAP;
        onOffButtonProperties.leftPosition = properties.BROWSER_LEFT_PADDING;
        onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
        onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
        onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
        onOffButtonProperties.target = contextTarget;
        onOffButtonProperties.dispatch = this.props.dispatch;

        var onOffVisibility = 'none';

        if ((this.isTextElement(contextTarget) == true || contextTarget.type == shapeTypes.ELLIPSE || contextTarget.type == shapeTypes.RECTANGLE  || contextTarget.type == shapeTypes.CHARACTER || contextTarget.type == shapeTypes.IMAGE || contextTarget.type == shapeTypes.TRIANGLE || contextTarget.type == shapeTypes.STAR || contextTarget.type == shapeTypes.HEART) && this.props.tab == modeType.FILL_STYLE)
            onOffVisibility = 'block';

        const onOffButtonHolderStyle = {
            display: onOffVisibility
        };

        var leftPosition = 0;

        if (this.props.accordionWidth > properties.BROWSER_WIDTH)
            leftPosition = (this.props.accordionWidth - properties.BROWSER_WIDTH) / 2;

        const elementsHolder = {
            position: 'absolute',
            top: 0,
            left: leftPosition,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            cursor: 'default'
        };

        var lastFocusalbeId1 = (operationType == modeType.LINE_STYLE) ? 'stylingMenuLastFocusableElement' : undefined;
        var lastFocusalbeId2 = (onOffVisibility == 'block') ? 'stylingMenuLastFocusableElement' : undefined;

        return (
            <div style={menuStyle} id="stylingMenu">
                <Title accordionWidth={this.props.accordionWidth}/>
                <div style={elementsHolder}>
                    <div style={buttonsWrapperStyle}>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={0} tab={this.props.tab} dispatch={this.props.dispatch} contextTarget={contextTarget}/>
                        <Button accordionWidth={properties.BROWSER_WIDTH} index={1} tab={this.props.tab} dispatch={this.props.dispatch} contextTarget={contextTarget}/>
                    </div>
                    <span style={spanStyle}>{text}</span>
                    <ColorPicker accordionWidth={properties.BROWSER_WIDTH} tab={operationType} topPosition={colorPickerTopPosition} shapeModel={contextTarget} dispatch={this.props.dispatch}/>
                    <div style={lineStyleHolder}>
                        <span style={spanThicknessStyle}>{locales.getCaption('LineThickness', 'stylingMenu')}</span>
                        <CustomSlider id={lastFocusalbeId1} properties={thicknessProperties}/>
                    </div>
                    <div style={onOffButtonHolderStyle}>
                        <OnOffToggleButton id={lastFocusalbeId2} properties={onOffButtonProperties} dispatch={this.props.dispatch} shapeModel={contextTarget}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const tab = state.menu.tab;
    const currentSlideModel = state.currentSlide.model;

    return {
        tab,
        currentSlideModel
    };
}

export const StylingMenu = connect(mapStateToProps)(StylingMenuContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/StylingMenu.js
 **/